import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EmptyStateIcon from '../../../../common/emptyStateIcons/emptyStatePurchases.svg';
import { simpleUrl } from '../../../../../config/paths';

const useStyles = makeStyles(() => ({
  image: {
    width: 195,
    height: 130,
    marginBottom: 40,
  },
  button: {
    width: 200,
    height: 40,
  },
  title: {
    fontWeight: 600,
    marginBottom: 10,
  },
  subtitle: {
    marginBottom: 20,
  },
}));

const EmptyState = () => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginTop="40px"
      flex={1}
      overflow="auto"
    >
      <img src={EmptyStateIcon} className={classes.image} />
      <Typography variant="h4" className={classes.title}>
        Aún no has realizado compras
      </Typography>
      <Typography variant="h5" className={classes.subtitle}>
        Verás aquí todos los productos realizados en Ripley
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={() => window.open(simpleUrl, '_blank')}
      >
        Ir a comprar
      </Button>
    </Box>
  );
};

export default EmptyState;
